import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationSharedService } from '../registration-shared.service';

@Injectable({
  providedIn: 'root',
})
export class StepSuccessGuard  {
  private registrationSharedService = inject(RegistrationSharedService);
  private router = inject(Router);
  
  constructor() {}

  canActivate(): boolean {
    if (this.registrationSharedService.registrationData.id) {
      return true;
    }

    this.router.navigate(['/']);

    return false;
  }
}
